export const getNationalBasePath = (): string =>
  window.location.pathname.split("/").slice(0, 4).join("/");
